import { format, formatDistanceToNowStrict, isPast } from 'date-fns';
import { Separator } from '@/components/ui/separator';
import { useAuthContext } from '@/context/auth-provider';
import { Badge } from '@/components/ui/badge';

function UserAccountInfo() {
    const { user } = useAuthContext();
    const lastPasswordChange = isPast(
        new Date(user.security.lastPasswordChange),
    )
        ? `${formatDistanceToNowStrict(new Date(user.security.lastPasswordChange))} ago`
        : format(user.security.lastPasswordChange, 'E, d MMM, yyyy | hh:mm aa');
    return (
        <div className='space-y-6 sm:space-y-2 p-6'>
            <h1 className='font-bold text-fluid-h1 mb-8'>Account</h1>
            <Separator />
            <div className='flex flex-col sm:flex-row items-center gap-2'>
                <span className='text-muted-foreground inline-block'>
                    Member since:
                </span>
                <span className='font-normal text-sm'>
                    {format(user.createdAt, 'E, d MMM, yyyy, hh:mm aa')}
                </span>
            </div>
            <div className='flex flex-col sm:flex-row items-center gap-2'>
                <span className='text-muted-foreground'>
                    Account Updated On:
                </span>
                <Badge variant={'default'}>
                    {format(user.updatedAt, 'E, d MMM, yyyy, hh:mm aa')}
                </Badge>
            </div>
            <div className='flex flex-col sm:flex-row items-center gap-2'>
                <span className='text-muted-foreground'>
                    Last Password Change:
                </span>
                <span className='text-foreground text-sm'>
                    {lastPasswordChange}
                </span>
            </div>
            <div className='flex flex-col items-center sm:items-start gap-2'>
                <p className='text-muted-foreground'>MFA Methods:</p>
                {user.security.mfa && user.security.mfa.length > 0
                    ? user.security.mfa.map((m) => (
                          <div
                              className='px-6 border-[1px] w-full h-12 flex justify-between items-center max-w-[14rem] rounded-md'
                              key={m.id}>
                              <span className='mx-2 block w-12 border-r-2 !pr-16'>
                                  {m.mfaMethod}
                              </span>
                              <Badge
                                  className={
                                      (m.isEnabled
                                          ? 'bg-success hover:bg-success/80'
                                          : 'bg-destructive hover:bg-destructive/80') +
                                      ' text-white w-12'
                                  }>
                                  <p className='w-full !text-center'>
                                      {m.isEnabled ? 'ON' : 'OFF'}
                                  </p>
                              </Badge>
                          </div>
                      ))
                    : null}
            </div>
        </div>
    );
}

export default UserAccountInfo;
